<template>
  <v-container fill-height>
    <v-layout justify-center>
      <v-flex>
        <span class="breadcrumbs__title">Crear / Editar</span>
        <v-icon>mdi-chevron-right</v-icon>
        <span>Proveedor</span>
        <v-divider class="mt-2"></v-divider>
        <Snackbar :textError="textError" :isSnackbar="isSnackbar" />
        <v-row class="mt-10">
          <v-col cols="12">
            <v-card class="mx-auto">
              <v-card-title class="text-h6 pl-4"
                >Información Básica</v-card-title
              >
              <div class="separator"></div>
              <v-divider></v-divider>
              <v-card-text class="text--primary pt-0">
                <v-form ref="form" v-model="valid" lazy-validation width="100%">
                  <!-- <v-row>
                    <v-col cols="4">
                      <v-card-title
                        class="text-h6 custom__title primary--text py-0 mt-2"
                        >Tipo de Proveedor
                      </v-card-title>
                      <v-radio-group
                        v-model="supplier.customerType"
                        class="mt-0"
                      >
                        <v-radio value="pj">
                          <template v-slot:label>
                            <div>Persona Jurídica</div>
                          </template>
                        </v-radio>
                        <v-radio value="pf">
                          <template v-slot:label>
                            <div>Persona Física</div>
                          </template>
                        </v-radio>
                      </v-radio-group>
                    </v-col>
                  </v-row> -->
                  <v-row class="form__row mt-5 dense_layout">
                    <v-col cols="3">
                      <v-text-field
                        label="Denominación jurídica"
                        v-model="supplier.businessName"
                        :rules="[...emptyField]"
                        required
                        outlined
                      ></v-text-field>
                    </v-col>
                    <!-- <v-col cols="4">
                      <v-text-field
                        label="Nombre Comercial"
                        v-model="supplier.tradename"
                        outlined
                      ></v-text-field>
                    </v-col> -->
                    <v-col cols="2">
                      <v-text-field
                        label="NIF"
                        v-model="supplier.nif"
                        :rules="id ? [...emptyField] : [...emptyField]"
                        required
                        outlined
                      ></v-text-field>
                    </v-col>
                    <!-- </v-row>
                  <v-row class="form__row dense_layout"> -->
                    <v-col cols="2">
                      <v-text-field
                        label="Persona de contacto"
                        v-model="supplier.contactPerson"
                        outlined
                      ></v-text-field>
                    </v-col>
                    <v-col cols="2">
                      <v-text-field
                        label="Cargo o posición"
                        v-model="supplier.contactPersonPosition"
                        outlined
                      ></v-text-field>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field
                        label="Correo electrónico"
                        v-model="supplier.email"
                        outlined
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <div v-if="id">
                    <v-card-title class="pl-0 text-h6"
                      >Documentación</v-card-title
                    >
                    <v-row>
                      <v-col cols="12" class="py-0">
                        <v-card-title
                          class="text-h6 custom__title primary--text py-0"
                          >Excepción requerimientos de documentos
                        </v-card-title>
                      </v-col>
                      <v-col cols="1" class="pt-0">
                        <v-radio-group
                          v-model="supplier.exceptDocs"
                          class="mt-0"
                        >
                          <v-radio :value="false">
                            <template v-slot:label>
                              <div>No</div>
                            </template>
                          </v-radio>
                          <v-radio :value="true">
                            <template v-slot:label>
                              <div>Si</div>
                            </template>
                          </v-radio>
                        </v-radio-group>
                      </v-col>
                      <v-col cols="8" v-if="supplier.exceptDocs">
                        <v-textarea
                          v-model="supplier.reasonExceptDocs"
                          outlined
                          name="input-7-4"
                          label="Motivo"
                          :rules="[...emptyField]"
                          required
                        ></v-textarea>
                      </v-col>
                    </v-row>
                    <div v-if="!supplier.exceptDocs">
                      <v-row>
                        <v-col cols="7">
                          <v-row>
                            <v-col cols="12">
                              <div class="text-subtitle-1">
                                Marcar las casillas de los documentos que
                                queremos solicitar al proveedor y pulsar enviar.
                              </div>
                              <v-divider></v-divider>
                              <div
                                class="
                                  .theme--light
                                  .v-label
                                  ml-16
                                  mt-5
                                  align-self-start
                                  font-weight-bold
                                "
                                v-if="supplier.lastTimeSent"
                              >
                                Fecha ultimo envío: {{ supplier.lastTimeSent
                                }}<br />
                                Persona que realizó el envío:
                                {{ supplier.lastSender }}
                              </div>
                            </v-col>
                            <v-col cols="12">
                              <v-checkbox
                                v-model="
                                  supplier.documentation.tributaryCertificate
                                "
                                label="Certificado de obligaciones tributarias, con resultado positivo de estar al corriente con una antigüedad máxima de 6 meses."
                                color="primary"
                                hide-details
                              ></v-checkbox>
                              <v-checkbox
                                id="uno"
                                v-model="supplier.documentation.nifCard"
                                label="Copia de la tarjeta acreditativa del NIF de la persona física o jurídica."
                                color="primary"
                                hide-details
                              ></v-checkbox>
                              <v-checkbox
                                v-model="supplier.documentation.ccCard"
                                label="Petición de Certificado de titularidad de la CC bancaria."
                                color="primary"
                                hide-details
                              ></v-checkbox>
                              <v-checkbox
                                v-model="supplier.documentation.ssCertificate"
                                label="Certificado de obligaciones con la Seguridad Social, con resultado positivo de estar al corriente con una antigüedad máxima de 6 meses "
                                color="primary"
                                hide-details
                              ></v-checkbox>
                              <v-checkbox
                                v-model="
                                  supplier.documentation.copyCertificateMS
                                "
                                label="Copia de la certificación del Sistema de Gestión de Compliance Penal o del Código Ético, vigentes en la empresa."
                                color="primary"
                              ></v-checkbox>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="5">
                          <v-row>
                            <v-col cols="12">
                              <div class="text-subtitle-1 py-0">
                                Enviar solicitud de requerimiento a la persona
                                de contacto?
                              </div>
                              <v-divider></v-divider>
                            </v-col>
                            <v-col cols="12" class="pb-0">
                              <v-radio-group
                                v-model="supplierEmail"
                                class="mt-0"
                              >
                                <v-radio
                                  :value="0"
                                  label="Si, a la persona de contacto"
                                >
                                </v-radio>
                                <v-radio :value="1" label="No, a otra persona">
                                </v-radio>
                              </v-radio-group>
                            </v-col>
                            <v-col cols="12" class="pt-0" v-if="!supplierEmail">
                              <v-btn
                                class="mb-5 white--text px-8"
                                color="primary"
                                @click="send"
                                >Enviar correo</v-btn
                              >
                            </v-col>
                            <v-col v-else cols="10" class="pt-0">
                              <v-row>
                                <v-col cols="8">
                                  <v-text-field
                                    dense
                                    label="Nuevo email"
                                    v-model="newEmailSender"
                                    outlined
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="4">
                                  <v-btn
                                    class="mb-5 white--text px-8"
                                    color="primary"
                                    @click="send"
                                    >Enviar correo</v-btn
                                  >
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </div>
                    <v-form
                      ref="form1"
                      v-model="valid1"
                      lazy-validation
                      width="100%"
                      v-if="!supplier.exceptDocs"
                    >
                      <v-card-title class="pl-0 text-h6 mt-4 pb-0"
                        >Justificación</v-card-title
                      >
                      <v-divider class="mb-3"></v-divider>
                      <v-row class="form__row dense_layout">
                        <v-col
                          cols="4"
                          class="check__box mt-2 d-flex align-center"
                        >
                          <v-label
                            >Copia de la tarjeta acreditativa del NIF de la
                            persona física o jurídica.</v-label
                          >
                        </v-col>
                        <v-col cols="3" class="py-0">
                          <v-tooltip
                            bottom
                            v-if="supplier.justification.nifCardInfo.whoUpload"
                          >
                            <template v-slot:activator="{ on }">
                              <v-file-input
                                label="Adjuntar archivo"
                                v-model="nifCardInfoFile"
                                @mouseenter.native="on.mouseenter"
                                @mouseleave.native="on.mouseleave"
                                @change="whoUpload('nifCardInfo')"
                              ></v-file-input>
                            </template>
                            <span>{{
                              supplier.justification.nifCardInfo.whoUpload
                            }}</span>
                          </v-tooltip>
                          <v-file-input
                            v-else
                            label="Adjuntar archivo"
                            v-model="nifCardInfoFile"
                            @change="whoUpload('nifCardInfo')"
                          ></v-file-input>
                        </v-col>
                        <v-col cols="1">
                          <v-icon
                            large
                            v-if="supplier.justification.nifCardInfo.file"
                            @click="
                              downloadFile(
                                supplier.justification.nifCardInfo.file,
                                supplier.justification.nifCardInfo.fileName
                              )
                            "
                          >
                            mdi-file-download-outline
                          </v-icon>
                        </v-col>
                        <v-col cols="2">
                          <v-menu
                            v-model="nifInfoDate"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="
                                  supplier.justification.nifCardInfo.date
                                "
                                label="Fecha de documento"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                outlined
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="supplier.justification.nifCardInfo.date"
                              @input="
                                nifInfoDate = false;
                                checkState('nifCardInfo');
                              "
                              locale="es-ES"
                              :first-day-of-week="1"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="2"
                          ><v-text-field
                            label="Estado"
                            readonly
                            v-model="supplier.justification.nifCardInfo.state"
                            outlined
                            :rules="
                              supplier.justification.nifCardInfo.date
                                ? docExpired
                                : []
                            "
                          ></v-text-field
                        ></v-col>
                      </v-row>
                      <v-row class="form__row dense_layout">
                        <v-col
                          cols="4"
                          class="check__box mt-2 d-flex align-center"
                        >
                          <v-label
                            >Certificado de obligaciones tributarias.</v-label
                          >
                        </v-col>
                        <v-col cols="3" class="py-0">
                          <v-tooltip
                            bottom
                            v-if="
                              supplier.justification.tributaryCertificateInfo
                                .whoUpload
                            "
                          >
                            <template v-slot:activator="{ on }">
                              <v-file-input
                                label="Adjuntar archivo"
                                v-model="tributaryCertificateInfoFile"
                                @mouseenter.native="on.mouseenter"
                                @mouseleave.native="on.mouseleave"
                                @change="whoUpload('tributaryCertificateInfo')"
                              ></v-file-input>
                            </template>
                            <span>{{
                              supplier.justification.tributaryCertificateInfo
                                .whoUpload
                            }}</span>
                          </v-tooltip>
                          <v-file-input
                            v-else
                            label="Adjuntar archivo"
                            v-model="tributaryCertificateInfoFile"
                            @change="whoUpload('tributaryCertificateInfo')"
                          ></v-file-input>
                        </v-col>
                        <v-col cols="1">
                          <v-icon
                            large
                            v-if="
                              supplier.justification.tributaryCertificateInfo
                                .file
                            "
                            @click="
                              downloadFile(
                                supplier.justification.tributaryCertificateInfo
                                  .file,
                                supplier.justification.tributaryCertificateInfo
                                  .fileName
                              )
                            "
                          >
                            mdi-file-download-outline
                          </v-icon>
                        </v-col>
                        <v-col cols="2">
                          <v-menu
                            v-model="tributaryCertificateInfoDate"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="
                                  supplier.justification
                                    .tributaryCertificateInfo.date
                                "
                                label="Fecha de documento"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                outlined
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="
                                supplier.justification.tributaryCertificateInfo
                                  .date
                              "
                              @input="
                                tributaryCertificateInfoDate = false;
                                checkState('tributaryCertificateInfo');
                              "
                              locale="es-ES"
                              :first-day-of-week="1"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="2"
                          ><v-text-field
                            label="Estado"
                            v-model="
                              supplier.justification.tributaryCertificateInfo
                                .state
                            "
                            readonly
                            outlined
                            :rules="
                              supplier.justification.tributaryCertificateInfo
                                .expire
                                ? docExpired
                                : []
                            "
                          ></v-text-field
                        ></v-col>
                      </v-row>
                      <v-row class="form__row dense_layout">
                        <v-col
                          cols="4"
                          class="check__box mt-2 d-flex align-center"
                        >
                          <v-label
                            >Certificado de obligaciones con la Seguridad
                            Social.</v-label
                          >
                        </v-col>
                        <v-col cols="3" class="py-0">
                          <v-tooltip
                            bottom
                            v-if="
                              supplier.justification.ssCertificateInfo.whoUpload
                            "
                          >
                            <template v-slot:activator="{ on }">
                              <v-file-input
                                label="Adjuntar archivo"
                                v-model="ssCertificateInfoFile"
                                @mouseenter.native="on.mouseenter"
                                @mouseleave.native="on.mouseleave"
                                @change="whoUpload('ssCertificateInfo')"
                              ></v-file-input>
                            </template>
                            <span>
                              {{
                                supplier.justification.ssCertificateInfo
                                  .whoUpload
                              }}
                            </span>
                          </v-tooltip>
                          <v-file-input
                            v-else
                            label="Adjuntar archivo"
                            v-model="ssCertificateInfoFile"
                            @change="whoUpload('ssCertificateInfo')"
                          ></v-file-input>
                        </v-col>
                        <v-col cols="1">
                          <v-icon
                            large
                            v-if="supplier.justification.ssCertificateInfo.file"
                            @click="
                              downloadFile(
                                supplier.justification.ssCertificateInfo.file,
                                supplier.justification.ssCertificateInfo
                                  .fileName
                              )
                            "
                          >
                            mdi-file-download-outline
                          </v-icon>
                        </v-col>
                        <v-col cols="2">
                          <v-menu
                            v-model="ssCertificateInfoDate"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="
                                  supplier.justification.ssCertificateInfo.date
                                "
                                label="Fecha de documento"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                outlined
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="
                                supplier.justification.ssCertificateInfo.date
                              "
                              @input="
                                ssCertificateInfoDate = false;
                                checkState('ssCertificateInfo');
                              "
                              locale="es-ES"
                              :first-day-of-week="1"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="2"
                          ><v-text-field
                            label="Estado"
                            v-model="
                              supplier.justification.ssCertificateInfo.state
                            "
                            readonly
                            outlined
                            :rules="
                              supplier.justification.ssCertificateInfo.expire
                                ? docExpired
                                : []
                            "
                          ></v-text-field
                        ></v-col>
                      </v-row>
                      <v-row class="form__row dense_layout">
                        <v-col cols="4" class="check__box d-flex align-center">
                          <v-label
                            >Copia de la certificación del Sistema de Gestión de
                            Compliance Penal o del Código Ético, vigentes en la
                            empresa.</v-label
                          >
                        </v-col>
                        <v-col cols="3" class="py-0">
                          <v-tooltip
                            bottom
                            v-if="
                              supplier.justification.copyCertificateMSInfo
                                .whoUpload
                            "
                          >
                            <template v-slot:activator="{ on }">
                              <v-file-input
                                label="Adjuntar archivo"
                                v-model="copyCertificateMSInfoFile"
                                @mouseenter.native="on.mouseenter"
                                @mouseleave.native="on.mouseleave"
                                @change="whoUpload('copyCertificateMSInfo')"
                              ></v-file-input>
                            </template>
                            <span
                              >{{
                                supplier.justification.copyCertificateMSInfo
                                  .whoUpload
                              }}
                            </span>
                          </v-tooltip>
                          <v-file-input
                            v-else
                            label="Adjuntar archivo"
                            v-model="copyCertificateMSInfoFile"
                            @change="whoUpload('copyCertificateMSInfo')"
                          ></v-file-input>
                        </v-col>
                        <v-col cols="1">
                          <v-icon
                            large
                            v-if="
                              supplier.justification.copyCertificateMSInfo.file
                            "
                            @click="
                              downloadFile(
                                supplier.justification.copyCertificateMSInfo
                                  .file,
                                supplier.justification.copyCertificateMSInfo
                                  .fileName
                              )
                            "
                          >
                            mdi-file-download-outline
                          </v-icon>
                        </v-col>
                        <v-col cols="2">
                          <v-menu
                            v-model="copyCertificateMSInfoDate"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="
                                  supplier.justification.copyCertificateMSInfo
                                    .date
                                "
                                label="Fecha de documento"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                outlined
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="
                                supplier.justification.copyCertificateMSInfo
                                  .date
                              "
                              @input="
                                copyCertificateMSInfoDate = false;
                                checkState('copyCertificateMSInfo');
                              "
                              locale="es-ES"
                              :first-day-of-week="1"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="2"
                          ><v-text-field
                            label="Estado"
                            v-model="
                              supplier.justification.copyCertificateMSInfo.state
                            "
                            readonly
                            outlined
                            :rules="
                              supplier.justification.copyCertificateMSInfo
                                .expire
                                ? docExpired
                                : []
                            "
                          ></v-text-field
                        ></v-col>
                      </v-row>
                      <v-row class="form__row dense_layout">
                        <v-col
                          cols="4"
                          class="check__box mt-2 d-flex align-center"
                        >
                          <v-label
                            >Copia del Certificado de titularidad de la CC
                            bancaria.</v-label
                          >
                        </v-col>
                        <v-col cols="3" class="py-0">
                          <v-tooltip
                            bottom
                            v-if="supplier.justification.ccCardInfo.whoUpload"
                          >
                            <template v-slot:activator="{ on }">
                              <v-file-input
                                label="Adjuntar archivo"
                                v-model="ccCardInfoFile"
                                @mouseenter.native="on.mouseenter"
                                @mouseleave.native="on.mouseleave"
                                @change="whoUpload('ccCardInfo')"
                              ></v-file-input>
                            </template>
                            <span>{{
                              supplier.justification.ccCardInfo.whoUpload
                            }}</span>
                          </v-tooltip>
                          <v-file-input
                            v-else
                            label="Adjuntar archivo"
                            v-model="ccCardInfoFile"
                            @change="whoUpload('ccCardInfo')"
                          ></v-file-input>
                        </v-col>
                        <v-col cols="1">
                          <v-icon
                            large
                            v-if="supplier.justification.ccCardInfo.file"
                            @click="
                              downloadFile(
                                supplier.justification.ccCardInfo.file,
                                supplier.justification.ccCardInfo.fileName
                              )
                            "
                          >
                            mdi-file-download-outline
                          </v-icon>
                        </v-col>
                        <v-col cols="2">
                          <v-menu
                            v-model="ccCardInfoDate"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="supplier.justification.ccCardInfo.date"
                                label="Fecha de documento"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                outlined
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="supplier.justification.ccCardInfo.date"
                              @input="
                                ccCardInfoDate = false;
                                checkState('ccCardInfo');
                              "
                              locale="es-ES"
                              :first-day-of-week="1"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="2"
                          ><v-text-field
                            label="Estado"
                            readonly
                            v-model="supplier.justification.ccCardInfo.state"
                            outlined
                            :rules="
                              supplier.justification.ccCardInfo.date
                                ? docExpired
                                : []
                            "
                          ></v-text-field
                        ></v-col>
                      </v-row>
                    </v-form>
                  </div>
                  <v-col cols="4">
                    <v-card-title
                      class="text-h6 custom__title primary--text py-0 mt-2"
                      >Aviso de embargo
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            class="text-h6 primary--text"
                            >mdi-information-outline</v-icon
                          >
                        </template>
                      </v-tooltip>
                    </v-card-title>
                    <v-radio-group v-model="supplier.embargo" class="2 mt-0">
                      <v-radio value="si">
                        <template v-slot:label>
                          <div>Si</div>
                        </template>
                      </v-radio>
                      <v-radio value="no">
                        <template v-slot:label>
                          <div>No</div>
                        </template>
                      </v-radio>
                    </v-radio-group>
                  </v-col>
                  <v-card-title class="pl-0 text-h6">Calificación</v-card-title>
                  <v-row class="form__row justify-center">
                    <v-col cols="4">
                      <v-text-field
                        label="Calificación Documental"
                        :value="supplierHasValidDocs() ? 'Apta' : 'No Apta'"
                        disabled
                        outlined
                      ></v-text-field>
                    </v-col>
                    <v-col cols="4">
                      <v-text-field
                        label="Calificación Técnica"
                        :value="calcularVEP(supplier.ratings)"
                        disabled
                        outlined
                      ></v-text-field>
                    </v-col>
                    <v-col cols="4">
                      <v-text-field
                        label="Calificación Final"
                        :value="
                          Number(calcularVEP(supplier.ratings)) >= 5 &&
                          supplierHasValidDocs()
                            ? 'Apta'
                            : 'No Apta'
                        "
                        outlined
                        disabled
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
                <div v-if="ratingsFiltradas && ratingsFiltradas.length > 0">
                  <p class="mt-10 primary--text">Calificaciones previas</p>
                  <!-- table Calificaciónes -->
                  <Table :headers="this.headers" :values="ratingsFiltradas" />
                </div>
              </v-card-text>
              <v-divider class="mb-2"></v-divider>
              <v-card-text class="pl-4">
                <v-btn
                  class="mb-5 white--text px-8"
                  :disabled="!valid"
                  color="primary"
                  @click="submit"
                  >Guardar</v-btn
                ><br />
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Table from "@/components/Table.vue";
import fieldValidation from "@/utils/fieldValidation.js";
import formatters from "@/utils/formatters.js";
import { formatVEP } from "@/utils/supplierEvaluation.js";
import { mapGetters, mapActions } from "vuex";
import Snackbar from "@/components/Snackbar";
import services from "@/services/services";
import router from "@/router";
export default {
  name: "CreateEditSupplier",
  props: ["id"],
  components: {
    Table,
    Snackbar,
  },
  data() {
    return {
      ccCardInfoFile: null,
      nifCardInfoFile: null,
      tributaryCertificateInfoFile: null,
      ssCertificateInfoFile: null,
      copyCertificateMSInfoFile: null,
      textError: null,
      isSnackbar: false,
      valid: false,
      valid1: false,
      supplierID: null,
      supplierEmail: 0,
      newEmailSender: null,
      supplier: {
        customerType: "pj",
        businessName: "",
        tradename: "",
        nif: "",
        contactPerson: "",
        email: "",
        promoter: "",
        embargo: "no",
        type: "proveedor",
        documentation: {
          nifCard: false,
          ssCertificate: false,
          tributaryCertificate: false,
          copyCertificateMS: false,
          ccCard: false,
        },
        // null if no previous emails has been sent
        lastTimeSent: null,
        lastSender: null,
        justification: {
          nifCardInfo: {
            isDoc: false,
            file: null,
            date: null,
            state: "",
            fileName: "",
            whoUpload: null,
          },
          tributaryCertificateInfo: {
            isDoc: false,
            file: null,
            date: null,
            state: "",
            expire: null,
            fileName: "",
            whoUpload: null,
          },
          ssCertificateInfo: {
            isDoc: false,
            file: null,
            date: null,
            state: "",
            expire: null,
            fileName: "",
            whoUpload: null,
          },
          copyCertificateMSInfo: {
            isDoc: false,
            file: null,
            date: null,
            state: "",
            expire: null,
            fileName: "",
            whoUpload: null,
          },
          ccCardInfo: {
            isDoc: false,
            file: null,
            date: null,
            state: "",
            expire: null,
            fileName: "",
            whoUpload: null,
          },
        },
        qualification: {
          qualification: 5,
          currentRating: "",
        },
        state: false,
        attachDoc: false,
        exceptDocs: false,
        reasonExceptDocs: "",
      },
      emptyField: [(v) => fieldValidation.emptyField(v)],
      emailField: [(v) => fieldValidation.validEmail(v)],
      nifField: [(v) => fieldValidation.validDniCifNie(v)],
      docExpired: [(v) => fieldValidation.expireDate(v)],
      checkIfNifExist: [(v) => fieldValidation.checkIfNifExist(v, "proveedor")],
      date: new Date().toISOString().substr(0, 10),
      nifInfoDate: false,
      tributaryCertificateInfoDate: false,
      ssCertificateInfoDate: false,
      copyCertificateMSInfoDate: false,
      ccCardInfoDate: false,
      search: "",
      headers: [
        { text: "Fecha evaluación", value: "date" },
        {
          text: "Nombre del expediente",
          align: "start",
          filterable: true,
          value: "contractName",
        },
        { text: "Calificación", value: "rate", align: "center" },
        { text: "Persona evaluadora", value: "evaluator" },
      ],
      mockValue: [],
      rolesGV: [1, 2],
    };
  },
  computed: {
    ...mapGetters([
      "getUserData",
      "getClientsAndSuppliers",
      "getUsers",
      "getVaildSuppliers",
      "getContracts",
    ]),
    // Filtrar valoraciones para mostrar solo las de contratos cerrados
    ratingsFiltradas() {
      if (!this.supplier.ratings || this.supplier.ratings.length === 0) {
        return [];
      }
      return this.supplier.ratings.filter((r) => {
        if (!r.contractID) return false; // Si no tiene contractID, excluir

        // Buscar el contrato por ID
        const contrato = this.getContracts.find((c) => c.id === r.contractID);

        // Solo incluir si el contrato está cerrado
        return contrato && contrato.contractState === "5-Expediente cerrado";
      });
    },
    promoter: {
      get() {
        if (this.supplier.promoter.length === 0 && this.getUserData)
          return `${this.getUserData.name} ${this.getUserData.surname}`;
        else if (this.getUsers.length !== 0) {
          let promotor = this.getUsers.find(
            (item) => item.id == this.supplier.promoter
          );
          if (promotor) {
            return `${promotor.name} ${promotor.surname}`;
          } else return "";
        } else return "";
      },
      set() {
        // this.supplier.promoter = this.getUserData.id;
        this.supplier.promoter =
          this.supplier.promoter.length !== 0
            ? this.supplier.promoter
            : this.getUserData.id;
      },
    },
    isPromotor() {
      return (
        this.getUserData &&
        this.getUserData.role.includes(3) &&
        this.getUserData.id === this.supplier.promoter
      );
    },
    isValidator() {
      return (
        this.getUserData &&
        this.getUserData.role.some((val) => this.rolesGV.includes(val))
      );
    },
  },
  watch: {
    getUserData() {
      this.supplier.promoter =
        this.supplier.promoter.length !== 0
          ? this.supplier.promoter
          : this.getUserData.id;
    },
    getClientsAndSuppliers() {
      if (this.id && this.getClientsAndSuppliers.length !== 0) {
        this.supplier = this.getClientsAndSuppliers.find(
          (item) => item.id === this.id
        );
        if (this.supplier.justification.ccCardInfo === undefined) {
          this.supplier.justification.ccCardInfo = {
            isDoc: false,
            file: null,
            date: null,
            state: "",
            expire: null,
            fileName: "",
            whoUpload: null,
          };
        }
        // this.supplier.justification.ccCard = this.supplier.justification.ccCardInfo;
      }
    },
    nifCardInfoFile() {
      this.supplier.justification.nifCardInfo.isDoc = this.nifCardInfoFile
        ? true
        : false;
      if (this.supplier.justification.nifCardInfo.isDoc) {
        this.supplier.justification.nifCardInfo.fileName =
          this.nifCardInfoFile.name;
      }
    },
    tributaryCertificateInfoFile() {
      this.supplier.justification.tributaryCertificateInfo.isDoc = this
        .tributaryCertificateInfoFile
        ? true
        : false;
      if (this.supplier.justification.tributaryCertificateInfo.isDoc) {
        this.supplier.justification.tributaryCertificateInfo.fileName =
          this.tributaryCertificateInfoFile.name;
      }
    },
    ssCertificateInfoFile() {
      this.supplier.justification.ssCertificateInfo.isDoc = this
        .ssCertificateInfoFile
        ? true
        : false;
      if (this.supplier.justification.ssCertificateInfo.isDoc) {
        this.supplier.justification.ssCertificateInfo.fileName =
          this.ssCertificateInfoFile.name;
      }
    },
    copyCertificateMSInfoFile() {
      this.supplier.justification.copyCertificateMSInfo.isDoc = this
        .copyCertificateMSInfoFile
        ? true
        : false;

      if (this.supplier.justification.copyCertificateMSInfo.isDoc) {
        this.supplier.justification.copyCertificateMSInfo.fileName =
          this.copyCertificateMSInfoFile.name;
      }
    },
    ccCardInfoFile() {
      this.supplier.justification.ccCardInfo.isDoc = this.ccCardInfoFile
        ? true
        : false;

      if (this.supplier.justification.ccCardInfo.isDoc) {
        this.supplier.justification.ccCardInfo.fileName =
          this.ccCardInfoFile.name;
      }
    },
    supplier() {
      if (this.supplier.justification.nifCardInfo.file) {
        this.nifCardInfoFile = new File(
          [this.supplier.justification.nifCardInfo.file],
          this.supplier.justification.nifCardInfo.fileName,
          {
            type: "text/plain",
          }
        );
        this.supplier.justification.nifCardInfo.isDoc = true;
      } else {
        this.supplier.justification.nifCardInfo.isDoc = false;
      }
      if (this.supplier.justification.tributaryCertificateInfo.file) {
        this.tributaryCertificateInfoFile = new File(
          [this.supplier.justification.tributaryCertificateInfo.file],
          this.supplier.justification.tributaryCertificateInfo.fileName,
          {
            type: "text/plain",
          }
        );
      } else {
        this.supplier.justification.tributaryCertificateInfo.isDoc = false;
      }
      if (this.supplier.justification.ssCertificateInfo.file) {
        this.ssCertificateInfoFile = new File(
          [this.supplier.justification.ssCertificateInfo.file],
          this.supplier.justification.ssCertificateInfo.fileName,
          {
            type: "text/plain",
          }
        );
      } else {
        this.supplier.justification.ssCertificateInfo.isDoc = false;
      }
      if (this.supplier.justification.copyCertificateMSInfo.file) {
        this.copyCertificateMSInfoFile = new File(
          [this.supplier.justification.copyCertificateMSInfo.file],
          this.supplier.justification.copyCertificateMSInfo.fileName,
          {
            type: "text/plain",
          }
        );
      } else {
        this.supplier.justification.copyCertificateMSInfo.isDoc = false;
      }
      if (this.supplier.justification.ccCardInfo.file) {
        this.ccCardInfoFile = new File(
          [this.supplier.justification.ccCardInfo.file],
          this.supplier.justification.ccCardInfo.fileName,
          {
            type: "text/plain",
          }
        );
      } else {
        this.supplier.justification.ccCardInfo.isDoc = false;
      }
      this.setDocState();
      this.supplier.promoter =
        this.supplier.promoter.length !== 0
          ? this.supplier.promoter
          : this.getUserData.id;
    },
    id() {
      if (this.id === undefined) {
        Object.assign(this.$data, this.$options.data.apply(this));
      }
    },
  },
  methods: {
    ...mapActions(["setActionsLoader"]),
    calcularVEP(ratings) {
      return formatVEP(ratings, this.getContracts);
    },

    async send() {
      //Save or Update
      let shouldSend = false;
      if (this.id || this.supplierID || this.$refs.form.validate()) {
        this.setActionsLoader(true);
        if (this.id || this.supplierID) {
          shouldSend = await this.update(false);
        } else {
          shouldSend = await this.save(false);
        }
      }
      //Send
      if (shouldSend) {
        // console.log("send email", shouldSend);
        // const attach = this.attachDoc ? " y con word file adjuntado" : "";
        // console.log(this.getUserData.email);
        // alert(
        //   `Envio de email a ${this.supplier.email} pediendo documentos${attach}. De ${this.getUserData.email}`
        // );
        let to =
          this.supplierEmail === 0 ? this.supplier.email : this.newEmailSender;
        let emailInfo = {
          emailType: "providerDocsEmailBody",
          docomentationToRequest: this.supplier.documentation,
          to: to,
          from: this.getUserData.email,
          supplier: {
            businessName: this.supplier.businessName,
            //contactPerson: this.supplier.contactPerson,
          },
          shouldAttach: this.supplier.documentation.copyCertificateMS,
          userWhoSend: `${this.getUserData.name} ${this.getUserData.surname}`,
        };
        //console.log(emailInfo);
        services.sendEmail(emailInfo).then(() => {
          //console.log(info);
          this.supplier.lastTimeSent = new Date().toLocaleString();
          this.supplier.lastSender = `${this.getUserData.name} ${this.getUserData.surname}`;
          this.update();
        });
      }
    },
    async submit() {
      //Send or Update
      if (this.$refs.form.validate()) {
        this.setActionsLoader(true);
        if (this.id) {
          Promise.all(this.uploadFilse(this.id))
            .then((urlsData) => {
              urlsData.forEach((url) => {
                if (url.includes("nifCardInfo.")) {
                  this.supplier.justification.nifCardInfo.file = url;
                } else if (url.includes("tributaryCertificateInfo.")) {
                  this.supplier.justification.tributaryCertificateInfo.file =
                    url;
                } else if (url.includes("ssCertificateInfo.")) {
                  this.supplier.justification.ssCertificateInfo.file = url;
                } else if (url.includes("ccCardInfo.")) {
                  this.supplier.justification.ccCardInfo.file = url;
                } else {
                  // copyCertificateMSInfo
                  this.supplier.justification.copyCertificateMSInfo.file = url;
                }
              });
              this.update();
            })
            .catch((error) => {
              console.log(`Some failed: `, error.message);
            });
        } else {
          let isSaved = await this.save();
          if (isSaved) {
            Promise.all(this.uploadFilse(this.supplierID))
              .then((urlsData) => {
                if (urlsData.length === 4) {
                  this.supplier.state = true;
                }
                urlsData.forEach((url) => {
                  if (url.includes("nifCardInfo.")) {
                    this.supplier.justification.nifCardInfo.file = url;
                  } else if (url.includes("tributaryCertificateInfo.")) {
                    this.supplier.justification.tributaryCertificateInfo.file =
                      url;
                  } else if (url.includes("ssCertificateInfo.")) {
                    this.supplier.justification.ssCertificateInfo.file = url;
                  } else if (url.includes("ccCardInfo.")) {
                    this.supplier.justification.ccCardInfo.file = url;
                  } else {
                    // copyCertificateMSInfo
                    this.supplier.justification.copyCertificateMSInfo.file =
                      url;
                  }
                });
                this.update();
              })
              .catch((error) => {
                this.setActionsLoader(false);
                console.log(`Some failed: `, error.message);
              });
          }
        }
      }
    },
    async save() {
      let that = this;
      return new Promise((resolve, reject) => {
        services
          .saveData("suppliers", this.supplier)
          .then((data) => {
            this.setActionsLoader(false);

            that.supplierID = data.id;
            resolve(true);
            this.textError = null;
            this.isSnackbar = true;
          })
          .catch((e) => {
            console.error(e);
            this.setActionsLoader(false);
            reject(false);
            this.textError = "Algo salió mal. Por favor, vuelva a intentarlo";
            this.isSnackbar = true;
          });
      });
    },
    async update(redirect = true) {
      return new Promise((resolve, reject) => {
        services
          .updateData("suppliers", {
            id: this.supplier.id || this.supplierID,
            payload: this.supplier,
          })
          .then(() => {
            if (redirect) {
              this.setActionsLoader(false);

              this.textError = null;
              this.isSnackbar = true;
              setTimeout(() => {
                //router.push("/suppliers/1");
                router.go(-1);
              }, 300);
            }
            resolve(true);
          })
          .catch((e) => {
            console.error(e);
            reject(false);
            this.textError = "Algo salió mal. Por favor, vuelva a intentarlo";
            this.isSnackbar = true;
          });
      });
    },
    uploadFilse(supplierId) {
      let filesPromises = [];
      if (this.nifCardInfoFile && this.nifCardInfoFile.type !== "text/plain") {
        filesPromises.push(
          services.files.uploadFile(
            "suppliers",
            "nifCardInfo." + supplierId + "-" + this.nifCardInfoFile.name,
            this.nifCardInfoFile
          )
        );
      }
      if (
        this.tributaryCertificateInfoFile &&
        this.tributaryCertificateInfoFile.type !== "text/plain"
      ) {
        filesPromises.push(
          services.files.uploadFile(
            "suppliers",
            "tributaryCertificateInfo." +
              supplierId +
              "-" +
              this.tributaryCertificateInfoFile.name,
            this.tributaryCertificateInfoFile
          )
        );
      }
      if (
        this.ssCertificateInfoFile &&
        this.ssCertificateInfoFile.type !== "text/plain"
      ) {
        filesPromises.push(
          services.files.uploadFile(
            "suppliers",
            "ssCertificateInfo." +
              supplierId +
              "-" +
              this.ssCertificateInfoFile.name,
            this.ssCertificateInfoFile
          )
        );
      }
      if (
        this.copyCertificateMSInfoFile &&
        this.copyCertificateMSInfoFile.type !== "text/plain"
      ) {
        filesPromises.push(
          services.files.uploadFile(
            "suppliers",
            "copyCertificateMSInfo." +
              supplierId +
              "-" +
              this.copyCertificateMSInfoFile.name,
            this.copyCertificateMSInfoFile
          )
        );
      }
      if (this.ccCardInfoFile && this.ccCardInfoFile.type !== "text/plain") {
        filesPromises.push(
          services.files.uploadFile(
            "suppliers",
            "ccCardInfo." + supplierId + "-" + this.ccCardInfoFile.name,
            this.ccCardInfoFile
          )
        );
      }

      return filesPromises;
    },
    checkState(field) {
      let docDate = new Date(
        formatters
          .formatDate(this.supplier.justification[field].date)
          .split("/")
          .reverse()
          .join("-")
      );
      let expireIn = 0;
      //if (field !== "nifCardInfo") {

      if (
        field === "tributaryCertificateInfo" ||
        field === "ssCertificateInfo"
      ) {
        expireIn = 6;
      } else if (field === "copyCertificateMSInfo") {
        expireIn = 12;
      }
      let docDateExp = this.addExpire(docDate, expireIn);
      this.supplier.justification[field].expire = docDateExp
        .toLocaleDateString()
        .split("/")
        .reverse()
        .join("-");
      //}

      let today = new Date();

      docDateExp.setHours(0, 0, 0, 0);
      today.setHours(0, 0, 0, 0);

      if (docDateExp >= today) {
        this.supplier.justification[field].state = "Vigente";
      } else {
        this.supplier.justification[field].state = "Caducado";
      }

      if (field === "nifCardInfo" || field === "ccCardInfo") {
        this.supplier.justification[field].state = "Vigente";
      }
    },
    addExpire(date, numberOfMonths) {
      return new Date(date.setMonth(date.getMonth() + numberOfMonths));
    },
    checkDocState(date) {
      return fieldValidation.checkState(date);
    },
    setDocState() {
      // check for expired docs
      if (this.supplier.justification.tributaryCertificateInfo.expire) {
        this.supplier.justification.tributaryCertificateInfo.state =
          this.checkDocState(
            this.supplier.justification.tributaryCertificateInfo.expire
          )
            ? "Vigente"
            : "Caducado";
      }
      if (this.supplier.justification.ssCertificateInfo.expire) {
        this.supplier.justification.ssCertificateInfo.state =
          this.checkDocState(
            this.supplier.justification.ssCertificateInfo.expire
          )
            ? "Vigente"
            : "Caducado";
      }
      if (this.supplier.justification.copyCertificateMSInfo.expire) {
        this.supplier.justification.copyCertificateMSInfo.state =
          this.checkDocState(
            this.supplier.justification.copyCertificateMSInfo.expire
          )
            ? "Vigente"
            : "Caducado";
      }

      // Reset documentation request
      // this.supplier.documentation = {
      //   nifCard: false,
      //   ssCertificate: false,
      //   tributaryCertificate: false,
      //   copyCertificateMS: false,
      // };
    },
    downloadFile(dataUrl, filename) {
      services.downloadFile(dataUrl, filename);
    },
    whoUpload(key) {
      this.supplier.justification[
        key
      ].whoUpload = `${this.getUserData.name} ${this.getUserData.surname}`;
    },
    supplierHasValidDocs() {
      let areValidDocs = this.getVaildSuppliers.findIndex(
        (supplier) => supplier.id === this.id
      );
      return areValidDocs >= 0;
    },
  },
  mounted() {
    [...document.querySelectorAll(".check__box .v-input__slot")].forEach(
      (element) => (element.style.cssText = "align-items: start !important")
    );
  },
  created() {
    if (this.getUserData) {
      this.supplier.promoter =
        this.supplier.promoter.length !== 0
          ? this.supplier.promoter
          : this.getUserData.id;
    }
    if (this.id && this.getClientsAndSuppliers.length !== 0) {
      this.supplier = this.getClientsAndSuppliers.find(
        (item) => item.id === this.id
      );
      if (this.supplier.justification.ccCardInfo === undefined) {
        this.supplier.justification.ccCardInfo = {
          isDoc: false,
          file: null,
          date: null,
          state: "",
          expire: null,
          fileName: "",
          whoUpload: null,
        };
      }
      this.setDocState();
    }
  },
};
</script>

<style scoped>
.v-icon.v-icon:after {
  background-color: white;
}
small {
  display: block;
  margin-top: -20px;
}
.breadcrumbs__title {
  padding: 8px 0;
  border-bottom: 3px solid #008076;
  margin: 0;
  display: inline-block;
}

.theme--light.v-image {
  align-self: center;
  border-radius: 10%;
}

.v-application--is-ltr .v-card__actions > .v-btn.v-btn + .v-btn {
  margin: 0;
}

.col-6 {
  padding: 0 12px;
}

.v-card__title.text-h6 {
  padding-left: 0px;
}

.custom__title {
  font-size: 16px !important;
}
</style>
